// extracted by mini-css-extract-plugin
module.exports = {"shp2-detail-D":"SHP2D_shp2-detail-D__1NGty"};